import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import scrollToContentStickyNavigations from 'components/home/home-page-content/content-sticky-navigations/utility'
import Typo from 'constants/typography'
import clsx from 'clsx'
import { segmentFeaturedCellClicked } from 'components/home/home-page-segment/homePageSegment'
import styles from './top-bubble-navigations.scss'
import homePageDuck from '../../../../home/duck'

const TopBubbleNavigations = ({
  isPhone,
  topNavigations,
  categoryProducts,
  selectedTopNavigation,
  updateSelectedTopNavigation,
}) => {
  const isFetching =
    categoryProducts?.didInvalidate || categoryProducts?.isFetching

  const handleClickNavigation = (navigation, index) => {
    segmentFeaturedCellClicked({
      ref_id: navigation?.id,
      cta_type: navigation?.attributes?.sub_type,
      position: index + 1,
      position_type: navigation?.attributes?.navigation_type,
    })
    updateSelectedTopNavigation(navigation)
    scrollToContentStickyNavigations()
  }

  if (!topNavigations) return null

  return (
    <div className={clsx('top-bubble-navigations')}>
      <style jsx>{styles}</style>
      {topNavigations.map((navigation, index) => {
        const isSelected = navigation?.id === selectedTopNavigation?.id

        return (
          <div
            tabIndex="0"
            role="button"
            key={navigation.id}
            className={clsx('top-bubble-navigations__button-link', {
              'selected-button': isSelected,
              'is-disabled': isFetching,
            })}
            onClick={() => handleClickNavigation(navigation, index)}
            onKeyUp={() => handleClickNavigation(navigation, index)}
          >
            <a
              className={isPhone ? Typo.body2 : Typo.body1}
              style={{
                color: navigation?.attributes?.title_info?.['text-color'],
              }}
            >
              {navigation.attributes.title}
            </a>
          </div>
        )
      })}
    </div>
  )
}

TopBubbleNavigations.propTypes = {
  categoryProducts: PropTypes.shape({
    didInvalidate: PropTypes.bool,
    isFetching: PropTypes.bool,
  }),
  isPhone: PropTypes.bool.isRequired,
  selectedTopNavigation: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  topNavigations: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      attributes: PropTypes.shape({
        navigation_type: PropTypes.string,
        sub_type: PropTypes.string,
        title: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        link_rewrite: PropTypes.string,
      }),
    }),
  ),
  updateSelectedTopNavigation: PropTypes.func.isRequired,
}

TopBubbleNavigations.defaultProps = {
  categoryProducts: {},
  selectedTopNavigation: null,
  topNavigations: [],
}

export default connect(
  (state) => ({
    isPhone: state.device.isPhone,
    categoryProducts: state.products,
    selectedTopNavigation: state.homePage.selectedTopNavigation,
    topNavigations: state.homePage.topNavigations,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateSelectedTopNavigation:
          homePageDuck.creators.updateSelectedTopNavigation,
      },
      dispatch,
    ),
)(TopBubbleNavigations)
